import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';

import {localDateShort, localFullDateLong, isoDate, isToday, getRelativeDay, getRelativeDayURI, isYesterday} from 'utils/LocalDateTimeHelper';
import { canonicalLink } from 'utils/seoUtils';
import config from 'config';

import Tabs from 'modules/Common/components/Tabs';
import RacecardsMeetingSummary from '../components/GreyhoundRacingRacecardsMeetingSummary';

export default class GreyhoundRacingResultsForDate extends Component {
  static propTypes = {
    routes: PropTypes.array.isRequired,
    date: PropTypes.string,
    meetingsByDate: PropTypes.object.isRequired,
    raceType: PropTypes.string
  };

  render() {
    var title;
    const convertToday = true;
    const convertYesterday = true;

    const cardDate = this.props.date;
    // build the date navigation array
    const dateNav = [], date = new Date();
    for (let i = 0; i < 7; i++) {
      const urlPart = getRelativeDayURI(date, 0, {convertToday, convertYesterday});
      const rawURLPart = getRelativeDayURI(date, 0, {convertToday: false, convertYesterday: false});
      let alternatives = [];
      if(urlPart != rawURLPart)
      {
        alternatives = [{href: `/greyhounds/results${rawURLPart}`, isIndex: isToday(date)}];
      }
      dateNav.push({ href: `/greyhounds/results${urlPart}`,
                    text: localDateShort(date, {convertToday,  convertYesterday}),
                    isIndex: isToday(date),
                    alternatives
                  });
      date.setDate(date.getDate() - 1);
    }

    const racecardsDate = cardDate ? isoDate(cardDate) : isoDate(new Date()),
          meetings = this.props.meetingsByDate[racecardsDate].meetings;

    if(isToday(racecardsDate)){
      title = 'Today\'s Results'
    }
    else if (isYesterday(racecardsDate)){
      title = 'Yesterday\'s Results'
    }
    else{
      title = `${localFullDateLong(racecardsDate)} Results`;
    }

    var {link = []} =  canonicalLink(this.props.routes, {date: getRelativeDay(racecardsDate, 0, {convertToday, convertYesterday})});
    if(!isToday(racecardsDate)){
      link.push({
        rel: "next",
        href: `${config.canonicalBase}/greyhounds/results${getRelativeDayURI(cardDate, 1, {convertToday, convertYesterday})}`
      });
    }

    link.push({
      rel: "prev",
      href: `${config.canonicalBase}/greyhounds/results${getRelativeDayURI(cardDate, -1, {convertToday, convertYesterday})}`
    });

    const helmetProps = {
      link
    }

    return (
      <div className="gh-racing-racecards">
        <MetaDataWrapper title={title} helmetProps={helmetProps} />
        <div className="gh-racing-racecards-header-container">
          <h1 className="page-main-title">{title}</h1>
          <Tabs tabs={dateNav}/>
        </div>
        <section className="gh-racing-content">
          {
            meetings && meetings.length > 0 ?
            <ul className="meetings">
              {meetings.map(meeting => (
                <li key={meeting.meeting_summary.meeting_reference.id}>
                  <RacecardsMeetingSummary meeting={meeting} date={racecardsDate} dateIncrement={-1}/>
                </li>
              ))}
            </ul>
          :
            <div className="gh-racing-racecards-none">
              <p>No meetings found</p>
            </div>
          }
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/components/GreyhoundRacingResultsForDate.js